module.exports = __webpack_public_path__ + "img/Recad.c83eb5f2.jpg";